export const runWeeklySubscriptions = `
  mutation RunWeeklySubscriptions {
    runWeeklySubscriptions {
      jobId
      status
      message
      sent
      failed
      error
    }
  }
`;
